import { Component, Input, OnInit } from '@angular/core';
import { Color } from 'ng2-charts';
import { ChartOptions } from 'chart.js';

@Component({
  selector: 'app-properties-card',
  templateUrl: './properties-card.component.html',
  styleUrls: ['./properties-card.component.scss']
})
export class PropertiesCardComponent implements OnInit{

  @Input() public itemCard;
  public productsValuesShowing = ['total_area', 'bedrooms', 'bathrooms', 'parkingspots']

  public data = {
    porcentagem: 100
  };

  public doughnutChartColorA: Color[] = [{
    borderColor: ['#75e29e', '#ccfaf0'],
    backgroundColor: ['#75e29e', '#ccfaf0']
  }];

  public doughnutChartOptions: ChartOptions = {
    cutoutPercentage: 80,
    legend: { display: false },
    tooltips: { enabled: false },
    elements: {
      arc: {
        borderWidth: 0
      },
    }
  };

  ngOnInit() {
    console.log(this.itemCard.photos[0])
  }

}
